<f-data-card>
  <div class="container privacy-policy">
    <div class="row">
      <div class="col-md-6 col-lg-6 privacy-policy-header">
        <h5>Privacy Policy</h5>
      </div>
    </div>

    <div class="row hide">
      <!-- Left Panel -->
      <div class="col-md-12 col-lg-6 privacy-policy-left">
    
        <div class="card-row">
          <h6 class="delivery-heading">Choose a delivery method:</h6>

          <section class="radio-selection" id="mobileNumbersSection">
            <mat-radio-group color="primary" class="account-selection custom-radio-selection" disableRipple
              aria-label="Select an option">

              <p class="privacy-content-heading"><strong>Text</strong></p>
              <mat-radio-button value="mobile1">
                <b>+1 </b>555-000-0001
              </mat-radio-button>
              <mat-radio-button value="mobile2">
                <b>+1 </b>555-000-0002
              </mat-radio-button>
              <mat-radio-button value="customMobile">
                <f-intl-tel-input defaultCountry="US" language="en-US" mandatory-country-code="true"
                  label-text="" helper-text="" class="clear-input">
                </f-intl-tel-input>
              </mat-radio-button>

              <p class="privacy-content-heading"><strong>Email</strong></p>
              <mat-radio-button value="email1">
                example1@email.com
              </mat-radio-button>
              <mat-radio-button value="email2">
                example2@email.com
              </mat-radio-button>
              <mat-radio-button class="custom-radio-width" value="customEmail">
                <mat-form-field appearance="fill" class="component-box">
                  <mat-label>Email address</mat-label>
                  <input matInput type="email" name="email">
                </mat-form-field>
              </mat-radio-button>

            </mat-radio-group>
          </section>
        </div>
      </div>

      <!-- Vertical Divider -->

      <!-- Right Panel -->
      <div class="col-md-12 col-lg-6 privacy-policy-right">
        <div class="card-row">
         <h6 class="delivery-heading">Choose language:</h6>
          <p class="privacy-content-heading">Select a language for the Privacy Policy message:</p>
          <section class="radio-selection">
            <mat-radio-group color="primary" class="account-selection custom-radio-selection" disableRipple
              aria-label="Select a language">
              <mat-radio-button value="english">English</mat-radio-button>
              <mat-radio-button value="french">French</mat-radio-button>
              <mat-radio-button value="spanish">Spanish</mat-radio-button>
            </mat-radio-group>
          </section>
        </div>
      </div>

      <div class="btn-refresh-container flex">
        <div class="btn-controls">
          <f-button text="Cancel" title="Cancel" type="button" variant="action"></f-button>
          <f-button text="Continue" title="Continue" type="button" variant="progressive" class="hide1"></f-button>
        </div>
                      </div>
    </div>
  </div>
</f-data-card>
